import React from 'react';
import { Heading, Stack, Button, Link } from '@chakra-ui/react';
import { Link as RouteLink } from 'react-router-dom';
import logo from '../../assets/logo.svg';
import styled from 'styled-components';
import DesktopMenu from './DesktopMenu';
import MobileMenu from './MobileMenu';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1rem;
  margin-bottom: 3rem;
`;

const Logo = styled.img`
    width: 2rem;
`;

const ButtonContainer = styled.div`
  @media only screen and (max-width: 760px) {
    display: none;
  }
`;

const Header = (props) => {
  return (
    <Container>
      <RouteLink to="/" style={{zIndex: 999}}>
        <Stack spacing="0.5rem" direction="row" align="center" _hover={{ cursor: 'pointer' }}>
          <Logo src={logo} />
          <Heading as="h1" size="lg" textColor="#B4BCD0" fontSize="1.5rem" fontFamily="Inter" fontWeight="600">Subsea</Heading>
        </Stack>
      </RouteLink>
      <DesktopMenu />
      <ButtonContainer>
        <Button
          as={Link}
          px="var(--button-px)"
          py="var(--button-py)"
          fontSize="var(--p2-font-size)"
          textColor="#fafafa"
          width="6rem"
          href="https://app.subseaprotocol.com"
          isExternal
          background="var(--components-primary-purple)"
          _hover={{textDecoration: 'none', filter: 'brightness(85%)'}}
          _focus={{outline: 'none', boxShadow: 'none'}}
          border="0.2px solid #7E9BD1"
          borderRadius="5px"
          height="2rem"
        >
          Enter App
        </Button>
      </ButtonContainer>
      <MobileMenu />
    </Container>
  );
}

export default Header;
